import { useLocation } from "react-router-dom";
import { SchoolContent } from "../../components/app";

export default function School() {
  let location = useLocation();

  return (
    <>
      {location?.state?.page === "details" ? (
        null
      ) : (
        <SchoolContent />
      )}
    </>
  );
}
